import './EventCard.scss';
import * as React from 'react';
import { FormattedDate, FormattedMessage } from 'react-intl';
import { SearchResultEvent } from 'src/state/SearchResult';
import { getClasses } from 'src/utils/classFunctions';
import { classList } from 'src/utils/classList';
import { ResponsiveImage } from 'src/components/ResponsiveImage';
import { IconChevronRight } from 'src/components/Icon/IconChevronRight';

type Props = {
    readonly modificators?: ReadonlyArray<string>;
    readonly variant?: string;
    readonly searchItem: SearchResultEvent;
};

export function EventCard(props: Props): JSX.Element {
    const { modificators = [], variant, searchItem } = props;

    return (
        <a href={searchItem.searchItem.url}
           target="_blank"
           className={classList(getClasses('lvo-event-card', modificators), variant)}>
            <div className="lvo-event-card__img-container lvo-event-card__img--center">
                <div className="lvo-event-card__img">
                    <ResponsiveImage src={searchItem.searchItem.image}/>
                </div>
            </div>
            <div className="lvo-event-card__info-wrapper">
                <div className="lvo-event-card__meta">
                    <div className="lvo-event-card__date">
                        {searchItem.eventStartDate && (
                            <FormattedDate value={searchItem.eventStartDate}
                                           year="numeric"
                                           month="2-digit"
                                           day="2-digit"/>
                        )}
                        <span> — </span>
                        {searchItem.eventEndDate && (
                            <FormattedDate value={searchItem.eventEndDate}
                                           year="numeric"
                                           month="2-digit"
                                           day="2-digit"/>
                        )}
                    </div>
                </div>
                <h4 className="lvo-event-card__title">
                    {searchItem.searchItem.title}
                </h4>

                {searchItem.eventLocation && (
                    <div className="lvo-event-card__location">
                        {searchItem.eventLocation}
                    </div>
                )}

                <div className="lvo-event-card__description">
                    {searchItem.searchItem.description}
                </div>
                <div className="lvo-event-card__link">
                    <div className="icon-box">
                        <IconChevronRight/>
                    </div>
                    <FormattedMessage id="searchPage_readMore"/>
                </div>
            </div>
        </a>
    );
}
